module.exports = __webpack_public_path__ + "img/scene_title_icon.65f719ec.png";